import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroLineItemsSection', {
    footerSubtotalText: 'Subtotal:',
    taxAdjustmentsTextLabel: 'Includes Adjustments to Tax:',
    footerTotalText: 'TOTAL:',
    differentSubtotalWarningDescription: '{templateName} subtotal differs from File subtotal',
    differentTaxTotalWarningDescription: '{templateName} tax total differs from File tax total',
    differentTotalWarningDescription: '{templateName} total differs from File total',
    differentSubtotalWarningLabel1: '{templateName} subtotal',
    differentSubtotalWarningLabel2: 'File subtotal',
    differentTaxTotalWarningLabel1: '{templateName} tax total',
    differentTaxTotalWarningLabel2: 'File tax total',
    differentTotalWarningLabel1: '{templateName} total',
    differentTotalWarningLabel2: 'File total',
});
